import React from "react";
import {Navbar, Nav, Container} from "react-bootstrap";
import {Link} from "react-router-dom";
import RegisterForm from "./forms/RegisterForm";
import {userRegisteration} from "./action";
import {FaCheckCircle, FaArrowRight} from "react-icons/fa";
import {connect} from "react-redux";

class RegisterPage extends React.Component{
    state = {
        viewModal: false
    };
    closeModal = () => {
        this.setState({viewModal : false});
    }
    submit = (data) =>
        this.props.userRegisteration(data)
            .then(token => {
                this.setState({viewModal: true, loading:false})
                localStorage.BookAppLogin = token.token; 
            });
    render(){
        return(
            <div>
                {this.state.viewModal &&
                <div className="success-modal-container">
                    <div className="success-modal">
                        <FaCheckCircle  className="icon"/>
                        <h1> Registeration Successfull </h1>
                        <h2> Please <span>Verify your Email</span> to secure your account </h2>
                        <div>
                        <a href="/main" className="visit_dashboard_btn w-100"
                        >Click Here to visit your book room <FaArrowRight /> </a>
                        {/*<button className="ok_btn" onClick={this.closeModal}
                        >Ok</button>*/}
                        </div>
                    </div>
                </div>
                }
                <Navbar expand="lg" variant="dark" className="bg-na fixed-top">
                    <Container>
                      <Link to="/"><Navbar.Brand className="nav-b">Back To Home</Navbar.Brand></Link>
                      <Nav className="ml-auto">
                          <Link className="nav-l" to="/signin">Sign In</Link>
                          <Link to="/register" className="hdf nav-la">Register</Link>
                      </Nav>
                    </Container>
                 </Navbar>
                 <header id="registerationHeader">
                     <h1>Please register below to create your book room</h1>
                 </header>
                 <div className="LoginMain register"
                 >
                    <RegisterForm submit={this.submit}/>
                </div>
            </div>
        );
    };
};

export default connect(null, {userRegisteration})(RegisterPage);